import { Project, Meeting, AgentAction } from '../types';

export const mockProjects: Project[] = [
  { id: '1', name: 'Website Redesign', epicCount: 12, storyCount: 38, color: '#22C99A', code: 'WR', healthScore: 85, onTrackPct: 80, atRiskPct: 15, blockedPct: 5 },
  { id: '2', name: 'Mobile App', epicCount: 8, storyCount: 24, color: '#4F6BFF', code: 'MA', healthScore: 78, onTrackPct: 72, atRiskPct: 18, blockedPct: 10 },
  { id: '3', name: 'AI Platform', epicCount: 15, storyCount: 52, color: '#FFBD59', code: 'AP', healthScore: 92, onTrackPct: 90, atRiskPct: 8, blockedPct: 2 },
  { id: '4', name: 'Data Migration', epicCount: 6, storyCount: 18, color: '#4F6BFF', code: 'DM', healthScore: 65, onTrackPct: 50, atRiskPct: 30, blockedPct: 20 },
  { id: '5', name: 'Customer Portal', epicCount: 10, storyCount: 29, color: '#FF6577', code: 'CP', healthScore: 88, onTrackPct: 85, atRiskPct: 10, blockedPct: 5 },
  { id: '6', name: 'Internal Tools', epicCount: 5, storyCount: 14, color: '#22C99A', code: 'IT', healthScore: 95, onTrackPct: 95, atRiskPct: 5, blockedPct: 0 },
];

export const mockMeetings: Meeting[] = [
  {
    id: '1',
    title: 'Product Sync',
    date: 'Oct 14, 2026',
    time: '10:00 - 10:45 AM',
    duration: '45m',
    type: 'past',
    participants: [
      { id: 'p1', name: 'Akhil' },
      { id: 'p2', name: 'Sarah' },
      { id: 'p3', name: 'John' },
      { id: 'p4', name: 'Jane' },
      { id: 'p5', name: 'Bob' },
      { id: 'p6', name: 'Alice' },
      { id: 'p7', name: 'Charlie' },
      { id: 'p8', name: 'Dave' },
    ],
    summary: 'The team discussed the progress on mobile app v2.0, focusing on the new authentication flow, analytics dashboard and beta release timeline. Key decisions were made regarding security implementation and resource allocation.',
    keyPoints: [
      'Agreed to move forward with biometric authentication',
      'Analytics dashboard to be delivered in Phase 2',
      'Beta release planned for Nov 15, 2026',
      'Need to coordinate with security team for compliance'
    ]
  },
  { id: '2', title: 'Sprint Planning', date: 'Oct 13, 2026', time: '11:00 - 12:00 PM', duration: '60m', type: 'past', participants: [{ id: 'p1', name: 'Akhil' }] },
  { id: '3', title: 'Client Review - ABC Corp', date: 'Oct 12, 2026', time: '3:00 - 4:00 PM', duration: '60m', type: 'past', participants: [{ id: 'p1', name: 'Akhil' }] },
  { id: '4', title: 'Design Review', date: 'Oct 11, 2026', time: '2:00 - 2:45 PM', duration: '45m', type: 'past', participants: [{ id: 'p1', name: 'Akhil' }] },
  { id: '5', title: 'Engineering Sync', date: 'Oct 10, 2026', time: '10:00 - 10:30 AM', duration: '30m', type: 'past', participants: [{ id: 'p1', name: 'Akhil' }] }
];

export const mockActions: AgentAction[] = [
  { id: 'a1', type: 'epic', description: 'Created 1 Epic in Jira: Mobile App v2.0', jiraKey: 'MOB-1234', status: 'completed', timestamp: '2026-10-14T10:30:00Z' },
  { id: 'a2', type: 'story', description: 'Created 4 Stories for authentication flow', jiraKey: 'MOB-1235, 1236...', status: 'completed', timestamp: '2026-10-14T10:32:00Z' },
  { id: 'a3', type: 'story', description: 'Created 2 Stories for analytics dashboard', jiraKey: 'MOB-1241, 1242', status: 'completed', timestamp: '2026-10-14T10:35:00Z' },
  { id: 'a4', type: 'brd', description: 'Generated BRD template for Mobile App v2.0', status: 'completed', timestamp: '2026-10-14T10:40:00Z' }
];
